// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
}

html {
  font-size: 10px;
}

body {
  min-width: 320px;
  min-height: 100vh;
  margin: 0;
}

h2 {
  padding-top: 0;
}

p {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/app/app.css"],"names":[],"mappings":"AAAA;EACE,wDAAwD;AAC1D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[":root {\r\n  font-family: Inter, Avenir, Helvetica, Arial, sans-serif;\r\n}\r\n\r\nhtml {\r\n  font-size: 10px;\r\n}\r\n\r\nbody {\r\n  min-width: 320px;\r\n  min-height: 100vh;\r\n  margin: 0;\r\n}\r\n\r\nh2 {\r\n  padding-top: 0;\r\n}\r\n\r\np {\r\n  background: transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
